// @ts-ignore ts-migrate(7016) FIXME: Try `npm install @types/isomorphic-fetch` if it ex... Remove this comment to see the full error message
import fetch from 'isomorphic-fetch';
import { isEmptyObject } from '../../core/util/object';
import { apiGetJson } from './index';
import { getCityLabelFromGeosuggestValue } from '../../components/Search/components/Filters/Fields/LocationInput/util';
import { safeGet } from '../util/object';
import ProxyTypes from '../proxy/ProxyTypes';

const getGeoCodeUrl = (address: any) =>
  `/proxy/${ProxyTypes.GeoCode}?address=${encodeURIComponent(address)}`;

const formatLatitudeLongitude = (latitudeLongitude: any) =>
  `${latitudeLongitude.lat},${latitudeLongitude.lng}`;

const getReverseGeoCodeUrl = (latitudeLongitude: any) =>
  `/proxy/geocode?latlng=${formatLatitudeLongitude(latitudeLongitude)}`;

const getGeoDataFromZip = async (zipCode: any) => {
  const response = await fetch(`/proxy/${ProxyTypes.ZipCode}?q=${zipCode}`).then((r: any) =>
    r.json()
  );

  const { latitude, longitude, city, state } = safeGet(response, {})('records.0.fields');
  return { latitude, longitude, city, state };
};

const parseLocationFromGeoCodeResult = (data: any) => {
  if (!isEmptyObject(data) && data.status === 'OK') {
    if (data.results && data.results.length > 0) {
      const latitudeLongitude = data.results[0].geometry.location;
      return {
        latitude: latitudeLongitude.lat,
        longitude: latitudeLongitude.lng,

        label: safeGet(data, '')('results.0.formatted_address').replace(', USA', ''),
      };
    }
  }

  return null;
};

const parseLocationFromReverseGeoCodeResult = (result: any) => {
  let city = null;
  let state = null;
  result.address_components.forEach((component: any) => {
    if (component.types.indexOf('locality') !== -1) {
      city = component.long_name;
    }

    if (component.types.indexOf('administrative_area_level_1') !== -1) {
      state = component.short_name;
    }
  });

  const location = {
    latitude: result.geometry.location.lat,
    longitude: result.geometry.location.lng,
    cityLabel: getCityLabelFromGeosuggestValue(result),
  };

  if (city && state) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'label' does not exist on type '{ latitud... Remove this comment to see the full error message
    location.label = `${city}, ${state}`;
  }

  return location;
};

const geoCode = (locationString: any, onSuccess: any, onError: any) => {
  apiGetJson(getGeoCodeUrl(locationString))
    .then((result: any) => {
      const location = parseLocationFromGeoCodeResult(result);
      if (location) {
        onSuccess(location);
      } else {
        onError(result);
      }
    })
    .catch((e: any) => onError(e));
};

export {
  geoCode,
  getGeoCodeUrl,
  getGeoDataFromZip,
  getReverseGeoCodeUrl,
  parseLocationFromGeoCodeResult,
  parseLocationFromReverseGeoCodeResult,
};
